import React, { useState } from "react";

const ParameterModal = ({ isOpen, onClose, onSave }) => {
  const [parameterName, setParameterName] = useState("");
  const [errors, setErrors] = useState("");

  const handleSave = () => {
    // Validation
    if (!parameterName || parameterName.trim() === "") {
      setErrors("Parameter name cannot be empty");
      return;
    }

    if (parameterName.length > 64) {
      setErrors("Parameter name must not exceed 64 characters");
      return;
    }

    // Call onSave callback
    onSave(parameterName.trim());
    
    // Reset form
    setParameterName("");
    setErrors("");
  };

  const handleClose = () => {
    setParameterName("");
    setErrors("");
    onClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSave();
    } else if (e.key === "Escape") {
      handleClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div data-rt-modal-overlay className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={(e) => { if (e.target === e.currentTarget) { const b = e.currentTarget.querySelector('[data-rt-modal-close], .close-btn, .modal-close, button[aria-label="Close"], button[aria-label="close"]'); if (b) b.click(); } }}>
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-md p-6 animate-in fade-in zoom-in duration-300">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-slate-900">Add Parameter</h2>
          <button
            onClick={handleClose}
            className="text-slate-500 hover:text-slate-700 text-2xl leading-none p-1 transition-colors"
            aria-label="Close modal"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="mb-6">
          <label className="block text-sm font-semibold text-slate-700 mb-2">
            Parameter Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={parameterName}
            onChange={(e) => {
              setParameterName(e.target.value);
              setErrors("");
            }}
            onKeyPress={handleKeyPress}
            placeholder="e.g., Username, Password, Email"
            className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all resize-none ${
              errors
                ? "border-red-500 focus:ring-red-500"
                : "border-slate-300 focus:ring-blue-500"
            }`}
            maxLength="64"
            autoFocus
          />
          <div className="flex items-center justify-between mt-2">
            <p className={`text-xs ${errors ? "text-red-500" : "text-slate-500"}`}>
              {errors || `${parameterName.length}/64 characters`}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex gap-3 justify-end">
          <button
            onClick={handleClose}
            className="px-6 py-2 border border-slate-300 text-slate-700 font-medium rounded-lg hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 transition-all"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-6 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all"
          >
            Save Parameter
          </button>
        </div>
      </div>
    </div>
  );
};

export default ParameterModal;
